import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Task } from '../../../shared/entities/task/task';

@Component({
  selector: 'nx-task-status-widget',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nx-default-box-v2>
      <!-- label -->
      <ng-template nxTemplate="label">
        <div class="text-[1rem] font-medium leading-3r mt-[2px]">
          Status
        </div>
      </ng-template>

      <!-- content -->
      <div class="flex flex-col space-y-1">
        <!-- p-tag must be conditionally rendered to prevent PrimeNG from caching
             stale severity styles during navigation. Without this guard, the tag
             renders with undefined severity before task data loads, and PrimeNG
             doesn't properly update the CSS classes when severity changes. -->
        @if (task()) {
          <p-tag
            [value]="stateLabel()"
            [severity]="stateSeverity()">
          </p-tag>
          @if(task()?.completedDateTime){
          <div>
            <app-user-name [user]="task()?.completedBy" />&nbsp;<app-relative-time [timestamp]="task()?.completedDateTime" />
          </div>
          }
          
        }
      </div>
    </nx-default-box-v2>
  `
})
export class TaskStatusWidgetComponent {

  // Signal-based input
  readonly task = input<Task>();

  // Computed signals for derived state
  readonly stateLabel = computed(() => this.task()?.getStateLabel() ?? '');
  readonly stateSeverity = computed(() => this.task()?.getStateSeverity());

}





